
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#eaeaea","d":"M30.4 16c0 7.953-6.447 14.4-14.4 14.4S1.6 23.953 1.6 16 8.047 1.6 16 1.6 30.4 8.047 30.4 16z"}}),_c('path',{attrs:{"fill":"#55565a","d":"M7.366 15.466v-5.199l6.394-.872v6.07H7.366zm7.46-6.225L23.36 8v7.466h-8.534V9.241zm8.534 7.293V24l-8.533-1.201v-6.266h11.53zm-9.6 6.13l-6.4-.876v-5.254h6.4v6.13z"}})])
          )
        }
      }
    